import { STORE_NAME } from './reducer';
import { UPDATE_SHOW_CAMERA_OFF_PARTICIPANTS } from './actions';
import { setTileViewDimensions, setVerticalViewDimensions } from 'jitsi/filmstrip/actions.web';
const getVideoGridState = (state) => {
    return state[STORE_NAME];
};
export const shouldHideCameraOffParticipants = (state) => {
    return getVideoGridState(state).hideCameraOffParticipants;
};
export const setHideCameraOffParticipants = (state) => {
    return {
        type: UPDATE_SHOW_CAMERA_OFF_PARTICIPANTS,
        state,
    };
};
export function toggleHideCameraOffParticipants(state) {
    return function (dispatch, getState) {
        dispatch(setHideCameraOffParticipants(state));
        dispatch(setTileViewDimensions());
        dispatch(setVerticalViewDimensions());
    };
}
